var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "details-view" },
    [
      _c(
        "cargo-left-right-resize",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: Boolean(_vm.action),
              expression: "Boolean(action)"
            }
          ],
          ref: "cargoLeftRightResize",
          staticStyle: { "min-height": "100%" },
          attrs: {
            "left-style": { flex: "none", "max-width": "220px" },
            "right-style": { overflow: "hidden" },
            "show-left": _vm.action === "look"
          }
        },
        [
          _c(
            "template",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.action === "look",
                  expression: "action==='look'"
                }
              ],
              slot: "left"
            },
            [
              _c(
                "div",
                {
                  staticStyle: {
                    "min-width": "180px",
                    width: "100%",
                    height: "100%",
                    padding: "10px 0px 10px"
                  }
                },
                [
                  _c("cargo-ag-grid", {
                    staticStyle: {
                      width: "100%",
                      height: "100%",
                      "min-height": "500px",
                      "padding-left": "16px"
                    },
                    attrs: {
                      "show-side-bar": false,
                      "grid-options": _vm.gridOptions,
                      "column-defs": _vm.gridOptions.columnDefs,
                      "row-data": _vm.rowData
                    },
                    on: {
                      gridReady: function(params) {
                        _vm.gridApi = params.api
                      }
                    }
                  })
                ],
                1
              )
            ]
          ),
          _c("template", { slot: "right" }, [
            _c("div", { staticClass: "main-content" }, [
              _c(
                "div",
                {
                  staticClass: "operations",
                  staticStyle: { "margin-bottom": "5px" }
                },
                [
                  _c(
                    "div",
                    { staticClass: "triggers", staticStyle: { flex: "none" } },
                    [
                      _c("cargo-button-group-slider", [
                        _c(
                          "div",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.action === "look",
                                expression: "action==='look'"
                              }
                            ]
                          },
                          [
                            _c(
                              "el-button",
                              {
                                attrs: { no: "back", type: "primary" },
                                on: { click: _vm.goBack }
                              },
                              [_vm._v(_vm._s(_vm.$t("common.btn.back")))]
                            ),
                            !_vm.isVerify
                              ? _c(
                                  "el-button",
                                  {
                                    attrs: { no: "edit", type: "success" },
                                    on: {
                                      click: function($event) {
                                        return _vm.editHandler()
                                      }
                                    }
                                  },
                                  [_vm._v(_vm._s(_vm.$t("SeaExport.Edit")))]
                                )
                              : _vm._e(),
                            _vm.isOrder &&
                            _vm.$checkPermission([
                              "button_FBAOrder_newFbaBookingOrders"
                            ])
                              ? _c(
                                  "el-button",
                                  {
                                    attrs: { no: "Clone", type: "primary" },
                                    on: {
                                      click: function($event) {
                                        return _vm.toCopy()
                                      }
                                    }
                                  },
                                  [_vm._v(_vm._s(_vm.$t("SeaExport.Clone")))]
                                )
                              : _vm._e(),
                            _vm.isOrder &&
                            _vm.currentRow.submitState === 2 &&
                            (_vm.currentRow.verifyState === 0 ||
                              _vm.currentRow.verifyState === 2 ||
                              _vm.currentRow.verifyState === 6) &&
                            _vm.$checkPermission([
                              "button_FBAOrder_notSubmitFbaBookingOrder"
                            ])
                              ? _c(
                                  "el-button",
                                  {
                                    attrs: { no: "notSubmit", type: "primary" },
                                    on: {
                                      click: function($event) {
                                        return _vm.toNotSubmit()
                                      }
                                    }
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t("CargoMsg.Cargo_HoldSubmission")
                                      )
                                    )
                                  ]
                                )
                              : _vm._e(),
                            _vm.isOrder &&
                            _vm.currentRow.submitState === 1 &&
                            _vm.$checkPermission([
                              "button_FBAOrder_submitFbaBookingOrder"
                            ])
                              ? _c(
                                  "el-button",
                                  {
                                    attrs: { no: "submit", type: "primary" },
                                    on: {
                                      click: function($event) {
                                        return _vm.toSubmit()
                                      }
                                    }
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(_vm.$t("CargoMsg.Cargo_Submit"))
                                    )
                                  ]
                                )
                              : _vm._e(),
                            _vm.$checkPermission([
                              "button_FBAOrder_printFbaBookingOrder"
                            ])
                              ? _c(
                                  "el-button",
                                  {
                                    attrs: { no: "print", type: "success" },
                                    on: { click: _vm.onPrint }
                                  },
                                  [_vm._v(_vm._s(_vm.$t("SeaExport.print")))]
                                )
                              : _vm._e(),
                            _vm.isVerify &&
                            _vm.$checkPermission([
                              "button_FBAVerify_acceptFbaBookingOrder"
                            ])
                              ? _c(
                                  "el-button",
                                  {
                                    attrs: {
                                      no: "approved",
                                      type: "primary",
                                      disabled:
                                        Number(_vm.currentRow.verifyState) !== 0
                                    },
                                    on: {
                                      click: function($event) {
                                        return _vm.toApproved()
                                      }
                                    }
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(_vm.$t("SeaExport.PassAudit"))
                                    )
                                  ]
                                )
                              : _vm._e(),
                            _vm.isVerify &&
                            _vm.$checkPermission([
                              "button_FBAVerify_rejectFbaBookingOrder"
                            ])
                              ? _c(
                                  "el-button",
                                  {
                                    attrs: {
                                      no: "refuse",
                                      type: "primary",
                                      disabled:
                                        Number(_vm.currentRow.verifyState) !== 0
                                    },
                                    on: {
                                      click: function($event) {
                                        return _vm.toRefuse()
                                      }
                                    }
                                  },
                                  [_vm._v(_vm._s(_vm.$t("SeaExport.Refuse")))]
                                )
                              : _vm._e(),
                            _vm.isVerify &&
                            _vm.isPretrialReviewFBA &&
                            _vm.$checkPermission([
                              "button_FBAVerify_reviewThroughFbaBookingOrder"
                            ])
                              ? _c(
                                  "el-button",
                                  {
                                    attrs: {
                                      no: "reApproved",
                                      type: "primary",
                                      disabled:
                                        Number(_vm.currentRow.verifyState) !== 1
                                    },
                                    on: {
                                      click: function($event) {
                                        return _vm.toReApproved()
                                      }
                                    }
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t("SeaExport.VerifyReviewThrough")
                                      )
                                    )
                                  ]
                                )
                              : _vm._e(),
                            _vm.isVerify &&
                            _vm.isPretrialReviewFBA &&
                            _vm.$checkPermission([
                              "button_FBAVerify_reviewRefusalFbaBookingOrder"
                            ])
                              ? _c(
                                  "el-button",
                                  {
                                    attrs: {
                                      no: "reRefuse",
                                      type: "primary",
                                      disabled:
                                        Number(_vm.currentRow.verifyState) !== 1
                                    },
                                    on: {
                                      click: function($event) {
                                        return _vm.toReRefuse()
                                      }
                                    }
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t("SeaExport.VerifyReviewRefusal")
                                      )
                                    )
                                  ]
                                )
                              : _vm._e(),
                            _c("img", {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: _vm.preVerifyStateIcon,
                                  expression: "preVerifyStateIcon"
                                }
                              ],
                              staticStyle: {
                                position: "fixed",
                                "z-index": "99",
                                right: "25%",
                                margin: "-10px 0 0 0"
                              },
                              attrs: {
                                src: _vm.preVerifyStateIcon,
                                width: "100",
                                height: "99"
                              }
                            })
                          ],
                          1
                        ),
                        _c(
                          "div",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.isNew || _vm.action === "edit",
                                expression: "(isNew || action==='edit')"
                              }
                            ],
                            staticClass: "new",
                            staticStyle: {
                              "border-left": "none",
                              "padding-left": "0"
                            }
                          },
                          [
                            _c(
                              "el-button",
                              {
                                attrs: { no: "save", type: "success" },
                                on: { click: _vm.saveHandler }
                              },
                              [_vm._v(_vm._s(_vm.$t("common.btn.save")))]
                            ),
                            _c(
                              "el-button",
                              {
                                attrs: { no: "cancel", type: "success" },
                                on: {
                                  click: function($event) {
                                    return _vm.cancelEdit()
                                  }
                                }
                              },
                              [_vm._v(_vm._s(_vm.$t("common.btn.cancel")))]
                            ),
                            _c(
                              "el-button",
                              {
                                attrs: {
                                  no: "SaveTheDefaultValues2",
                                  type: "primary"
                                },
                                on: { click: _vm.saveDefaultVal }
                              },
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t("SeaExport.SaveTheDefaultValues")
                                  )
                                )
                              ]
                            )
                          ],
                          1
                        )
                      ])
                    ],
                    1
                  )
                ]
              ),
              _c(
                "div",
                {
                  staticClass: "tabs-container",
                  staticStyle: { position: "relative" }
                },
                [
                  _c(
                    "el-tabs",
                    {
                      ref: "tabs",
                      staticStyle: { width: "100%" },
                      attrs: { type: "card" },
                      on: { "tab-click": _vm.handleTabClick },
                      model: {
                        value: _vm.activeTabName,
                        callback: function($$v) {
                          _vm.activeTabName = $$v
                        },
                        expression: "activeTabName"
                      }
                    },
                    [
                      _c(
                        "el-tab-pane",
                        {
                          attrs: {
                            label: _vm.$t("SeaExport.Consignation"),
                            lazy: true,
                            name: "tabBaseInfo"
                          }
                        },
                        [
                          _c("tab-order-info", {
                            ref: "tabBaseInfo",
                            attrs: {
                              context: _vm.parentContext,
                              action: _vm.action,
                              "view-source": _vm.viewSource
                            },
                            on: { onRefresh: _vm.onRefresh }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-tab-pane",
                        {
                          attrs: {
                            label: _vm.$t("SeaExport.Charge"),
                            lazy: true,
                            name: "tabCharges"
                          }
                        },
                        [
                          _c("tab-charges", {
                            ref: "tabCharges",
                            attrs: {
                              context: _vm.parentContext,
                              action: _vm.action,
                              "view-source": _vm.viewSource
                            }
                          })
                        ],
                        1
                      ),
                      !_vm.isNew && _vm.currentRow.uuid
                        ? _c(
                            "el-tab-pane",
                            {
                              attrs: {
                                label: _vm.$t("SeaExport.FileHistory"),
                                lazy: true,
                                name: "tabFileHistory"
                              }
                            },
                            [
                              _c("tab-file-history", {
                                ref: "tabFileHistory",
                                attrs: { context: _vm.parentContext }
                              })
                            ],
                            1
                          )
                        : _vm._e()
                    ],
                    1
                  )
                ],
                1
              )
            ])
          ])
        ],
        2
      ),
      _c("cargo-template-selector-dialog", {
        ref: "templateSelectorDialog",
        attrs: {
          visible: _vm.templateSelectorDialog.visible,
          ctx: _vm.templateSelectorDialog.ctx,
          category: _vm.templateSelectorDialog.category,
          data: _vm.templateSelectorDialog.data,
          context: _vm.parentContext,
          "pre-print-callback": _vm.prePrintCallback,
          "printed-callback": _vm.printedCallback,
          "v2-check-callback": _vm.v2CheckCallback
        },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.templateSelectorDialog, "visible", $event)
          }
        }
      }),
      _vm.opVerifyFrameDialog.visible
        ? _c("fba-op-verify-frame-dialog", {
            attrs: {
              visible: _vm.opVerifyFrameDialog.visible,
              "job-model": _vm.opVerifyFrameDialog.job || {},
              "submit-call-back": _vm.opVerifyFrameDialog.submitCallBack
            },
            on: {
              "update:visible": function($event) {
                return _vm.$set(_vm.opVerifyFrameDialog, "visible", $event)
              }
            }
          })
        : _vm._e(),
      _vm.rejectWindow.visible
        ? _c("op-verify-frame-reject", {
            attrs: {
              visible: _vm.rejectWindow.visible,
              "job-no": _vm.rejectWindow.jobNo,
              type: "fba",
              "reject-call-back": _vm.rejectWindow.rejectCallBack
            },
            on: {
              "update:visible": function($event) {
                return _vm.$set(_vm.rejectWindow, "visible", $event)
              }
            }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }